'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shallowequal = require('./shallowequal');

var _shallowequal2 = _interopRequireDefault(_shallowequal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (inst, nextProps, nextState) {
  var props = inst.props;
  var state = inst.state;

  if (nextProps.shouldComponentUpdate) {
    return nextProps.shouldComponentUpdate({
      nextProps: nextProps,
      props: props,
      nextState: nextState,
      state: state
    });
  }

  return !(0, _shallowequal2.default)(nextProps, props) || !(0, _shallowequal2.default)(nextState, state);
}; /**
    * Copyright (c) 2015-present, Zippy Technologies
    *
    * This source code is licensed under the MIT license found in the
    * LICENSE file in the root directory of this source tree.
    */